import { MeetingPdfStatusQuery, MeetingPdfStatusQueryVariables } from '../../../types'
import { MEETING_PDF_STATUS } from '../MeetingQueries'
import { useQuery } from '@apollo/client'

export const useMeetingPdfStatus = (
  meetingId: number,
): {
  data: MeetingPdfStatusQuery | undefined
  startPolling: (pollInterval: number) => void
  stopPolling: () => void
} => {
  const { data, startPolling, stopPolling } = useQuery<MeetingPdfStatusQuery, MeetingPdfStatusQueryVariables>(MEETING_PDF_STATUS, {
    variables: {
      meetingId: meetingId,
    },
  })

  return { data, startPolling, stopPolling }
}
